<template>
  <section class="Fallback">
    <img class="Fallback-logo" src="@/assets/images/kenzo-homme-logo.svg" alt="">
    <div class="Fallback-content">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 654.99 433.54"><g fill="white" id="Layer_2" data-name="Layer 2"><g id="Calque_1" data-name="Calque 1"><path class="cls-1" d="M616.42,353.56H38.58l0-313.85C38.66,39.29,44.42-2.42,91,.11H564c46.56-2.54,52.31,39.18,52.36,39.6l0,.37Zm-571.84-6H610.42V40.29c-.43-3-6.17-36.38-46.13-34.18H90.72c-40-2.2-45.7,31.12-46.14,34.18Z"/><path class="cls-1" d="M333.51,433.54h-15l-251.07-.18c-20.09,1.27-36.1-4.06-47.61-15.85-9.58-9.82-16-24.38-18.57-42.1a113.83,113.83,0,0,1-1-23.95l.25-2.74h654l.24,2.74a113.83,113.83,0,0,1-1,23.95c-2.56,17.72-9,32.28-18.56,42.1-11.52,11.8-27.55,17.13-47.61,15.85l-251.08.18Zm-9-6h9l254.27-.18h.1c18.3,1.19,32.77-3.55,43-14.05,17.89-18.33,18.33-49.28,18-58.6H6.07c-.3,9.33.17,40.32,18,58.61,10.26,10.5,24.73,15.21,43,14h.19l257.17.18Z"/><g id="_360" data-name="360"><path class="cls-1" d="M235.65,257.06l-2.09-2.61A120.23,120.23,0,0,1,327.5,59.18a118.92,118.92,0,0,1,75,26.29l2.61,2.09L363.77,129l-2-1.36a61.71,61.71,0,0,0-34.13-10.26h-.09a62.08,62.08,0,0,0-51.82,96.3l1.36,2.05ZM327.5,65.18A114.36,114.36,0,0,0,213.27,179.41a112.93,112.93,0,0,0,22.91,68.64l33.19-33.18A68.09,68.09,0,0,1,327.5,111.33h.1A67.61,67.61,0,0,1,363,121.27l33.18-33.18A112.93,112.93,0,0,0,327.5,65.18Z"/><path class="cls-1" d="M327.5,299.62a118.86,118.86,0,0,1-75-26.3l-2.62-2.09,41.39-41.38,2.05,1.35a62.08,62.08,0,0,0,86-86L378,143.13l41.38-41.38,2.09,2.62A120.22,120.22,0,0,1,327.5,299.62ZM258.87,270.7a112.87,112.87,0,0,0,68.63,22.92A114.35,114.35,0,0,0,441.72,179.4a112.88,112.88,0,0,0-22.91-68.63l-33.18,33.17a68.09,68.09,0,0,1-93.58,93.58Z"/><g class="cls-2"><path class="cls-1" d="M297.05,182.53V178.9a7.42,7.42,0,0,0,3.63-.6,3.72,3.72,0,0,0,1.66-3.39,3.81,3.81,0,0,0-1.21-2.93,4.21,4.21,0,0,0-3.08-1.15,4,4,0,0,0-2.73.85,5.68,5.68,0,0,0-1.38,3h-4.23a9.75,9.75,0,0,1,2.69-5.83,8.24,8.24,0,0,1,5.71-1.84,8.43,8.43,0,0,1,6,2.18,7.28,7.28,0,0,1,2.33,5.6,6.93,6.93,0,0,1-3.06,6q3.49,2.06,3.5,6.69a8.15,8.15,0,0,1-2.55,6.2,9.16,9.16,0,0,1-6.54,2.4q-5.08,0-7.55-3.73A9.69,9.69,0,0,1,289,188h4.1a5,5,0,0,0,1.59,3.12,4.89,4.89,0,0,0,3.31,1.09,4.6,4.6,0,0,0,3.41-1.37,4.91,4.91,0,0,0,1.35-3.55,4.34,4.34,0,0,0-2-4.05A7.58,7.58,0,0,0,297.05,182.53Z"/><path class="cls-1" d="M325.08,166.47l3.12,2.34L321.47,178l.93-.1a5.37,5.37,0,0,1,.6,0,7.91,7.91,0,0,1,5.93,2.62,8.72,8.72,0,0,1,2.48,6.24,9.44,9.44,0,0,1-9.39,9.38,9.48,9.48,0,0,1-6.71-2.71,8.65,8.65,0,0,1-2.82-6.44,12.14,12.14,0,0,1,2.75-7.07Zm2.19,20.47a5.34,5.34,0,1,0-5.3,5.25,5.33,5.33,0,0,0,5.3-5.25Z"/><path class="cls-1" d="M335.05,181.34q0-6.72,3.13-10.73a8.18,8.18,0,0,1,13.6,0q3.14,4,3.13,10.92t-3.13,10.9a8.35,8.35,0,0,1-6.78,3.62,8.46,8.46,0,0,1-6.82-3.62Q335,188.41,335.05,181.34Zm4.17,0a16.52,16.52,0,0,0,1.63,7.78q1.62,3,4.13,3.05t4.14-3.05a18.64,18.64,0,0,0,0-15.29q-1.64-3-4.14-3t-4.12,3A15.6,15.6,0,0,0,339.22,181.36Z"/><path class="cls-1" d="M368.55,167a5.32,5.32,0,0,1,3.92,1.66,5.62,5.62,0,0,1-4,9.58,5.6,5.6,0,0,1-5.63-5.61,5.35,5.35,0,0,1,1.66-4A5.53,5.53,0,0,1,368.55,167Zm0,2.81a3,3,0,0,0-2.13.81,2.72,2.72,0,0,0-.86,2,3,3,0,0,0,.88,2.17,2.81,2.81,0,0,0,2.07.89,2.75,2.75,0,0,0,2.08-.89,3,3,0,0,0,.88-2.17,2.69,2.69,0,0,0-.86-2A2.8,2.8,0,0,0,368.51,169.85Z"/></g></g></g></g></svg>
      <p>
        {{$t('fallback')}}
      </p>
    </div>
    <nav class="Fallback-RSLinks">
      <IconButton href="https://www.instagram.com/kenzoparfums/">
        <img src="@/assets/images/instagram.svg" alt="">
      </IconButton>
      <IconButton href="https://www.facebook.com/kenzoparfums">
        <img src="@/assets/images/facebook.svg" alt="">
      </IconButton>
      <IconButton href="https://www.linkedin.com/company/kenzo-parfums/">
        <img src="@/assets/images/linkedin.svg" alt="">
      </IconButton>
    </nav>
  </section>
</template>

<script>
import IconButton from '@/components/IconButton'

export default {
  components: {
    IconButton
  }
}
</script>

<style lang="stylus" scoped>
.Fallback
  width 100%
  height 100vh
  background black
  position fixed
  top 0
  left 0
  z-index 9999
  color white
  background-image url('../assets/bali-background.jpg')
  background-size cover
  align-items center
  justify-content center
  display none

  &-logo
    position absolute
    z-index 5
    left 50%
    transform translateX(-50%)
    max-width 210px
    width 40vw
    top 6vh
  p 
    text-align center
  &-content
    padding 10%
    background rgba(255,255,255, 0.2)
    border-radius 3px
    text-align center
    width 500px
    max-width 80%
    > svg
      width 210px
      // width 160px
      display inline-block
      margin-bottom 3vw
  &-RSLinks
    display flex
    width 300px
    align-items center
    justify-content center
    position absolute
    z-index 5
    bottom 5%
    left 50%
    transform translateX(-50%)
    >>> .IconButton
      margin 0 20px 

@media only screen and (max-device-width: 1024px)
  .Fallback
    display flex

@media only screen and (max-device-width: 1024px) and (orientation: landscape)
  .Fallback
    padding 5%
    &-logo
      width 40vh
    &-content
      > svg
        width 100px
</style>